var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlugType2Medium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,21c0-2.2060547-1.7939453-4-4-4s-4,1.7939453-4,4s1.7939453,4,4,4S16,23.2060547,16,21z M12,23 c-1.1025391,0-2-0.8974609-2-2s0.8974609-2,2-2s2,0.8974609,2,2S13.1025391,23,12,23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,28c-2.2060547,0-4,1.7939453-4,4s1.7939453,4,4,4s4-1.7939453,4-4S20.2060547,28,18,28z M18,34 c-1.1025391,0-2-0.8974609-2-2s0.8974609-2,2-2s2,0.8974609,2,2S19.1025391,34,18,34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,28c-2.2060547,0-4,1.7939453-4,4s1.7939453,4,4,4s4-1.7939453,4-4S32.2060547,28,30,28z M30,34 c-1.1025391,0-2-0.8974609-2-2s0.8974609-2,2-2s2,0.8974609,2,2S31.1025391,34,30,34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,21c0-2.2060547-1.7939453-4-4-4s-4,1.7939453-4,4s1.7939453,4,4,4S28,23.2060547,28,21z M24,23 c-1.1025391,0-2-0.8974609-2-2s0.8974609-2,2-2s2,0.8974609,2,2S25.1025391,23,24,23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,17c-2.2060547,0-4,1.7939453-4,4s1.7939453,4,4,4s4-1.7939453,4-4S38.2060547,17,36,17z M36,23 c-1.1025391,0-2-0.8974609-2-2s0.8974609-2,2-2s2,0.8974609,2,2S37.1025391,23,36,23z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 12,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 12,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8808594,4.1904297C36.7099609,4.0664062,36.5048828,4,36.2939453,4H11.7060547 c-0.2109375,0-0.4160156,0.0664062-0.5869141,0.1904297C5.4091797,8.3271484,2,14.9853516,2,22c0,12.1308594,9.8691406,22,22,22 s22-9.8691406,22-22C46,14.9853516,42.5908203,8.3271484,36.8808594,4.1904297z M24,42C12.9716797,42,4,33.0283203,4,22 c0-6.2695312,2.9970703-12.2265625,8.0341797-16h23.9316406C41.0029297,9.7734375,44,15.7304688,44,22 C44,33.0283203,35.0283203,42,24,42z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugType2Medium);
export default __webpack_public_path__ + "static/media/plug-type-2--medium.e2d347811b4751d794a8c9eae1d95ed8.svg";
export { ForwardRef as ReactComponent };